<script>export let title;
export let siteName;
export let language;
export let url;
export let metaDescription;
export let metaImage;
export let openGraph;
$:
  ogImage = getOgImage(metaImage, openGraph);
function getOgImage(metaImage2, openGraph2) {
  if (metaImage2?.url && metaImage2?.alt && metaImage2?.height && metaImage2?.width) {
    return {
      url: metaImage2.url,
      alt: metaImage2.alt,
      height: metaImage2.height.toString(),
      width: metaImage2.width.toString()
    };
  }
  if (openGraph2) {
    return {
      url: openGraph2.url,
      alt: openGraph2.alt || metaDescription,
      height: openGraph2.height.toString(),
      width: openGraph2.width.toString()
    };
  }
  return null;
}
</script>

<svelte:head>
  <meta property="og:site_name" content="{siteName}" />
  <meta property="og:locale" content="{language}" />
  <meta property="og:url" content="{url}" />
  <meta property="og:type" content="website" />
  <meta property="og:title" content="{title}" />
  <meta property="og:description" content="{metaDescription}" />
  {#if ogImage}
    <meta property="og:image" content="{ogImage.url}" />
    <meta property="og:image:width" content="{ogImage.width}" />
    <meta property="og:image:height" content="{ogImage.height}" />
    <meta property="og:image:alt" content="{ogImage.alt}" />
  {/if}
</svelte:head>
